import React from 'react';

interface HistoricMonumentsContentProps {
  monuments: any[];
}

const HistoricMonumentsContent: React.FC<HistoricMonumentsContentProps> = ({ monuments }) => {
  if (!monuments || monuments.length === 0) {
    return (
      <div style={{ marginBottom: '16px', color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
        Aucun monument historique trouvé
      </div>
    );
  }

  return (
    <>
      {monuments.map((monument, index) => (
        <div key={index}>
          {monument.properties?.appellation_courante && (
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#333' }}>Nom:</strong> {monument.properties.appellation_courante}
            </div>
          )}
          
          {monument.properties?.adresse && (
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#333' }}>Adresse:</strong> {monument.properties.adresse}
            </div>
          )}
          
          {monument.properties?.distance?.calculated && (
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#333' }}>Distance:</strong> {Math.floor(monument.properties.distance.calculated)}m
            </div>
          )}
          
          {monument.properties?.precision_protection && (
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#333' }}>Protection:</strong> {monument.properties.precision_protection}
            </div>
          )}
          
          {monument.properties?.historique && (
            <div style={{ marginBottom: '16px' }}>
              <strong style={{ color: '#333' }}>Historique:</strong><br/>
              <span style={{ color: '#666', lineHeight: 1.4 }}>
                {monument.properties.historique}
              </span>
            </div>
          )}
          
          {index < monuments.length - 1 && (
            <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />
          )}
        </div>
      ))}
    </>
  );
};

export default HistoricMonumentsContent;
